export enum ApplicationCode {
  Request = "PRE",
  Report = "TDR",
}
